import { Circle, Fill, Icon, Stroke, Style } from 'ol/style';

import {
  addFeaturesToLayer,
  createFeatureUsingGeojsonGeometry,
} from 'utils/map/layers';
import {
  OPERATION_ICON,
  OPERATION_ICONS_BACK,
  STATUS_COLORS,
} from 'consts/mapConfig';

export const addOperationsToLayer = (layer, approvals) => {
  const features = [];
  for (const approval of approvals) {
    const feature = createFeatureUsingGeojsonGeometry(
      approval.operation?.geojson || approval.geojson
    );
    feature.setId(approval.uid);
    feature.setProperties({
      detail: 'approval',
      status: approval.status,
    });
    setOperationFeatureStyle(feature, approval);
    features.push(feature);
  }
  addFeaturesToLayer(layer, features);
};

export const setOperationFeatureStyle = (feature, approval) => {
  if (!feature) return;
  feature.setStyle(basicOperationStyle(approval));
};

const basicOperationStyle = approval => [
  new Style({
    image: new Circle({
      stroke: new Stroke({
        color: STATUS_COLORS[approval.status]?.stroke || STATUS_COLORS.default,
        width: OPERATION_ICONS_BACK.strokeWidth,
      }),
      radius: OPERATION_ICONS_BACK.radius,
    }),
  }),
  new Style({
    image: new Icon({
      src: OPERATION_ICON.src,
      scale: OPERATION_ICON.scale,
      color: STATUS_COLORS[approval.status]?.stroke || STATUS_COLORS.default,
    }),
  }),
  new Style({
    image: new Circle({
      fill: new Fill({
        color: 'rgba(0,0,0,0)',
      }),
      radius: OPERATION_ICONS_BACK.radius,
    }),
  }),
];
